/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {WinPresentationController} from "../WinPresentationController";
import {TombstoneRip} from "../../TombstoneRip";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {gsap} from "gsap";
import {TombstoneScatter} from "../../symbol/TombstoneScatter";
import {TombstoneRipSound} from "../../sound/TombstoneRipSound";

export class FreespinWinController extends WinPresentationController {

    constructor() {
        super("FreespinWinController", false);
    }

    protected hasWin():boolean {
        const data = TombstoneRip.model.parsedGameData;
        return data.mode != GameMode.FREESPIN && data.nextMode === GameMode.FREESPIN;
    }

    protected async createWinAnimation():Promise<any> {
        if(TombstoneRip.playFSWin) {
            const tl = gsap.timeline();
            TombstoneRip.model.parsedGameData.scatterPositions!.forEach((symId, reelId) => {
                if(symId > -1) {
                    const symbol = <TombstoneScatter>TombstoneRip.reels[reelId].getSymbol(symId);
                    const symTl = gsap.timeline();
                    symTl.to(symbol.scale, {duration : 0.2, x : 1.3, y : 1.3})
                        .to(symbol.scale, {duration : 0.5, x : 1, y : 1});
                    tl.add(() => {
                        TombstoneRip.reels[reelId].reelView.addWinSymbol(symbol);
                        symbol.playWin(false);
                    }, 0);
                    tl.add(symTl, 0);
                }
            });
            tl.add(gsap.to(this, {duration : 1}), 0);
            tl.add(() => {TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.SCATTER_WIN, volume : 1})});
            await Promise.resolve(tl);
        }

        await new Promise<void>(resolve => {
            TombstoneRip.xBetController.featureVisible = false
            TombstoneRip.freespinIntro.show(() => {
                TombstoneRip.keypadPlugin.setZeroBetSpinCounter(TombstoneRip.model.parsedGameData.freespinsLeft);
                resolve();
            });
        });
    }
}